import { createSingleAction } from 'store/utils';

const SET_OPEN_PROMOTION_DEMOTION = 'employment_management/SET_OPEN_PROMOTION_DEMOTION';
export const setOpenPromotionDemotion = createSingleAction<
boolean,
typeof SET_OPEN_PROMOTION_DEMOTION
>(
    SET_OPEN_PROMOTION_DEMOTION,
);
